import React from 'react';
import { JbLogoInline } from './jbLogoInline';
import { styles } from './HeaderJbLogo.styles.css';
import { useTrackingContext } from '../../../Tracking';
import { Link } from '../../../PlatformFunctionality';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export const HeaderJbLogo = ({ subtitle }: { subtitle?: string }) => {
  const { tracker } = useTrackingContext();
  return (
    <div className={styles.logoContainer}>
      <Link
        href="/"
        onClick={() => tracker.trackClick({ label: 'JB Hi-Fi', extraData: { group: 'logo-home' } })}
        className={styles.link}
        data-testid="header-jb-logo"
      >
        <JbLogoInline className={styles.logo({ hasSubtitle: Boolean(subtitle) })} />
        <CalloutFont className={styles.subtitle}>{subtitle}</CalloutFont>
      </Link>
    </div>
  );
};
